/**
 * EffortGraphSpec is the specification for a graph of effort used in clustering.
 */
export function slicePointSet(dataPoints, spec) {
    const lastPointIndexPlusOne = dataPoints.length - spec.recentPointsToIgnore;
    if (lastPointIndexPlusOne <= 0)
        return null;
    let firstPointIndex = spec.maxPointCount == Infinity ? 0 : lastPointIndexPlusOne - spec.maxPointCount;
    if (firstPointIndex < 0)
        firstPointIndex = 0;
    if (lastPointIndexPlusOne - firstPointIndex < spec.minPointCount)
        return null;
    return dataPoints.slice(firstPointIndex, lastPointIndexPlusOne);
}
